export enum ComplianceDocumentIdentifier {
  EPC = "epc",
  PROOF_OF_OWNERSHIP = "proof_of_ownership",
  ID_AML_CHECK = "id_aml_check",
  SIGNED_TCS = "signed_tcs"
}

export enum DocumentStatus {
  COMPLETED = "Completed",
  INCOMPLETE = "Incomplete",
  EXPIRED = "Expired",
  INVALID = "Invalid"
}

interface Owner {
  name: string;
  documentUrl: string | null;
}

export interface PropertyDocs {
  identifier: ComplianceDocumentIdentifier.EPC | ComplianceDocumentIdentifier.PROOF_OF_OWNERSHIP;
  status: DocumentStatus;
  documentUrl: string | null;
  metadata: string | null;
  dateValue?: string | null;
}

export interface OwnerDocs {
  identifier: ComplianceDocumentIdentifier.ID_AML_CHECK | ComplianceDocumentIdentifier.SIGNED_TCS;
  status: DocumentStatus.COMPLETED | DocumentStatus.INCOMPLETE;
  owners: Owner[];
}
